import {
  AddItemsToCartMutation,
  ProductCartItem,
} from '../__generated__/graphql';

export const getStockMessageFromResultByProductId = (
  productId: string,
  result: AddItemsToCartMutation['addItemsToCart']['products'] | undefined
) => {
  let stockMessage: string | undefined = undefined;
  const currentProduct = result?.find(
    product =>
      product.__typename === 'ProductCartItem' &&
      product?.product.id === productId
  ) as ProductCartItem;
  if (currentProduct) {
    stockMessage = currentProduct.stockMessageCode as string;
  }
  return stockMessage;
};
